import { buildQueryParams } from 'utils/helper';

// Tab types
export type MappingTab = 'maximor-data-tables' | 'raw-data-tables';

// Default values
export const DEFAULT_MAPPING_TAB: MappingTab = 'maximor-data-tables';

export const mappingURLs = {
  base: '/central-data-hub/mapping',
  _base_relative_path: 'mapping',

  // Tab URLs
  maximorDataTables: '/central-data-hub/mapping/maximor-data-tables',
  _maximorDataTables_relative_path: 'maximor-data-tables',

  rawDataTables: '/central-data-hub/mapping/raw-data-tables',
  _rawDataTables_relative_path: 'raw-data-tables',

  // Helper to build tab URL
  tab: (tab: MappingTab) => `/central-data-hub/mapping/${tab}`,

  // Product split page
  productSplitByGLAccount: ({
    period,
    id,
  }: {
    period?: string;
    id: string;
  }) => {
    const url = '/central-data-hub/mapping/maximor-product-percent-split';
    const queryParams = buildQueryParams({ period, id });
    return queryParams ? `${url}?${queryParams}` : url;
  },
} as const;
